import api from './api';

// Talks to /api/cogs-posting — where material consumption and factory labour
// land in the ledger. The same shape as revenuePostingService, because they are
// the same kind of thing: a CATALOGUE of posting rules, not captured data.
//
// Resolution is by weight, most specific wins, resolved LATERAL in the cost
// views. The weights differ per catalogue and the labour one is the trap:
//
//   material   stock_code 8 > stock_group 4 > product_class 2 > site 1
//   labour     pay_category 8 > component_type 4 > function_code 2 > site 1
//
// A labour rule naming only a function CANNOT outrank one naming a pay
// category — to target ordinary extrusion hours the rule has to name both.
export const cogsPostingService = {
  // { material, labour, picks, unposted }
  //
  // `unposted` is the figure that matters most: cost that is budgeted and
  // costed but resolves to no account, so it is absent from the P&L, the cash
  // flow and the balance sheet with no error raised anywhere.
  get: async () => {
    const res = await api.get('/cogs-posting');
    return res.data;
  },

  // kind = 'material' | 'labour'. Admin only.
  save: async (kind, rules) => {
    const res = await api.put(`/cogs-posting/${kind}`, { rules });
    return res.data;
  },

  remove: async (kind, postingId) => {
    const res = await api.delete(`/cogs-posting/${kind}/${postingId}`);
    return res.data;
  },
};

export default cogsPostingService;
